import React from 'react';

import { ReactionsLoader } from '@confluence/reactions/entry-points/ReactionsLoader';
import { ReactionContainerType, ReactionLocation } from '@confluence/reactions';
import { getCachedPageData } from '@confluence/live-pages-utils/entry-points/getCachedPageData';
import { usePageContentId, useContentType, usePageSpaceKey } from '@confluence/page-context';

export const ObjectCommentPageReactions = () => {
	const [contentId] = usePageContentId();
	const [contentType] = useContentType();
	const [spaceId] = usePageSpaceKey();

	const { subType } = getCachedPageData(contentId);

	return (
		<ReactionsLoader
			contentId={contentId || ''}
			location={contentType === 'blogpost' ? ReactionLocation.BLOGPOST : ReactionLocation.PAGE}
			containerId={spaceId || ''}
			containerType={
				contentType === 'blogpost' ? ReactionContainerType.BLOGPOST : ReactionContainerType.PAGE
			}
			contentSubType={subType}
			summaryViewEnabled
			summaryViewThreshold={1}
			allowSelectFromSummaryView={false}
			useButtonAlignmentStyling
			summaryViewPlacement="top-start"
			hideNoReactionsText
			readOnly={false}
			isSubtle
			useDefaultStyledContainer
			// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
			hidePlaceholder={Boolean(process.env.REACT_SSR || window.__SSR_RENDERED__)}
			noRelativeContainer={false}
			noFlexWrap={false}
			pickerQuickReactionEmojiIds={[]}
		/>
	);
};
